import React, { useState } from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import Colors from "../../constants/Colors";
import { useSelector, useDispatch } from "react-redux";
import DefaultText from "../../components/text/DefaultText";
import { Ionicons } from "@expo/vector-icons";
import Device from "../../models/device";
import * as deviceActions from "../../store/actions/device";
import firebase from "firebase";

const PairDeviceScreen = (props) => {
  const dispatch = useDispatch();
  const userDevices = useSelector((state) => state.devices.myDevices);
  let deviceId = 1;
  if (userDevices.length === 0) {
    deviceId = 1;
  } else {
    deviceId = parseInt(userDevices[userDevices.length - 1].deviceId) + 1;
  }
  const userId = firebase.auth().currentUser.uid;
  const newDevice = new Device(
    deviceId,
    userId,
    `Device ${deviceId}`,
    {
      power: "ON",
      play: true,
      volume: 100,
      mute: false,
      brightness: 100,
      brightAuto: false,
      speed: "5mins",
    },
    []
  );

  return (
    <View style={styles.screen}>
      <Ionicons name="qr-code-outline" size={150} color="white" />

      <View style={styles.textContainer}>
        <DefaultText style={{ fontSize: 16 }}>
          Scan the QR Code from the frame{" "}
        </DefaultText>
      </View>
      <TouchableOpacity
        style={styles.buttonContainer}
        onPress={() => {
          dispatch(deviceActions.pairDevice(newDevice));
          props.navigation.navigate("DeviceScreen");
        }}
      >
        <Text style={styles.pairText}>Pair Device</Text>
      </TouchableOpacity>
      {/* </View> */}
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: "black",
    alignItems: "center",
    justifyContent: "center",
  },
  textContainer: {
    padding: 5,
  },
  buttonContainer: {
    backgroundColor: "white",
    width: "90%",
    height: 48,
    alignItems: "center",
    justifyContent: "center",
    margin: 50,
  },
});

export default PairDeviceScreen;
